module.exports = __webpack_public_path__ + "static/media/icon_3_3.9d066544.svg";